import { memo } from 'react';
import { SearchTableHeaderButton } from '../search-table-header-button';
import * as SX from './sx';
import { type ShareLinkButtonProps as Props } from './types';
import { useShareSearchLink } from './use-share-search-link';

export const ShareLinkButton = memo((props: Props) => {
  const { className, compact, disabled } = props;
  const { share, isSharing } = useShareSearchLink();

  return (
    <SearchTableHeaderButton
      className={className}
      text="Share Link"
      icon={isSharing && compact ? undefined : 'share-outline'}
      variant="text"
      color="default"
      compact={compact}
      disabled={disabled || isSharing}
      loading={isSharing}
      sx={SX.root(compact)}
      onClick={share}
    />
  );
});

ShareLinkButton.displayName = 'ShareLinkButton';
